/**
 * Device fingerprint — stable per-device identifier stored in localStorage.
 * Used by PIN flow (US-E1-003) to bind PIN to (user, device).
 *
 * Trade-off: weak fingerprint (clearing storage = losing PIN), but no consent
 * dialog needed and no third-party deps. v0.5.0+ may upgrade to FingerprintJS.
 */
const DEVICE_ID_KEY = 'agentceo_device_id'
const DEVICE_LABEL_KEY = 'agentceo_device_label'

/** Get or create a stable device ID. Idempotent. */
export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY)
  if (!id) {
    id = generateUUID()
    localStorage.setItem(DEVICE_ID_KEY, id)
  }
  return id
}

/** Human-readable label like "Chrome на macOS" — for Settings list of trusted devices. */
export function getDeviceLabel(): string {
  let label = localStorage.getItem(DEVICE_LABEL_KEY)
  if (!label) {
    label = inferDeviceLabel()
    localStorage.setItem(DEVICE_LABEL_KEY, label)
  }
  return label
}

/** Reset device id — used after explicit "log out from all devices" or PIN reset. */
export function resetDeviceId(): void {
  localStorage.removeItem(DEVICE_ID_KEY)
  localStorage.removeItem(DEVICE_LABEL_KEY)
}

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  // Fallback for old browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

function inferDeviceLabel(): string {
  const ua = navigator.userAgent
  let browser = 'Браузер'
  if (/Edg\//.test(ua)) browser = 'Edge'
  else if (/Chrome\//.test(ua) && !/Chromium/.test(ua)) browser = 'Chrome'
  else if (/Firefox\//.test(ua)) browser = 'Firefox'
  else if (/Safari\//.test(ua) && !/Chrome/.test(ua)) browser = 'Safari'
  else if (/YaBrowser\//.test(ua)) browser = 'Яндекс Браузер'

  let os = ''
  if (/Windows/.test(ua)) os = 'Windows'
  else if (/Mac OS X|Macintosh/.test(ua)) os = 'macOS'
  else if (/iPhone|iPad|iPod/.test(ua)) os = 'iOS'
  else if (/Android/.test(ua)) os = 'Android'
  else if (/Linux/.test(ua)) os = 'Linux'

  return os ? `${browser} на ${os}` : browser
}
